import React from 'react'
import MatchInfo from './MatchInfo'

const GeneralMatchInfoContainer = () => {
  return <MatchInfo />
}

export default GeneralMatchInfoContainer
